var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-main',[_c(_setup.AppBar,{on:{"logout":_setup.logout}}),_c('div',{staticClass:"main-container"},[_c(_setup.StatusBar),_c('div',{staticClass:"section"},[_c(_setup.SecurityTab),_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }